



































export default {
    props: {
        TransportLicense: String,
        CmrReminder: String,
        PaymentNotific: String,
        NotificationEmail: String,
        formstyle: Object,
        lists: Object,
        validate: Boolean,
    },
    watch: {
        validate(this: any, newVal: any, oldVal: any) {
            this.checkAndEmit();
        },
    },
    data(this: any): any {
        return {
            rules: {
                NotificationEmail: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
                CmrReminder: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
            },
            formObject: {
                TransportLicense: '',
                CmrReminder: '',
                PaymentNotific: '',
                NotificationEmail: '',
            },
        };
    },
    methods: {
        async checkAndEmit(this: any) {
            this.$emit('TransportLicense', this.formObject.TransportLicense);
            this.$emit('CmrReminder', this.formObject.CmrReminder);
            this.$emit('PaymentNotific', this.formObject.PaymentNotific);
            this.$emit('NotificationEmail', this.formObject.NotificationEmail);
            this.$refs.form.validate((val: any) => {
                this.$emit('ok');
            });
        },
    },
    beforeMount(this: any) {
        this.formObject.TransportLicense = this.TransportLicense;
        this.formObject.CmrReminder = this.CmrReminder;
        this.formObject.PaymentNotific = this.PaymentNotific;
        this.formObject.NotificationEmail = this.NotificationEmail;
    },
};
